import {TaxAccountantConsultationDetail} from "@/features/manage";

import {Indicator} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";
import {Suspense} from "react";

export const Route = createFileRoute(
	"/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/"
)({
	component: TaxAccountantConsultationDetailPage
});

function TaxAccountantConsultationDetailPage() {
	return (
		<Suspense fallback={<Indicator />}>
			<TaxAccountantConsultationDetail />
		</Suspense>
	);
}
